import DB from './dbWrapper'

const install = function(Vue) {
  // 1. add global method or property
  Vue.InitDb = function(DbConfig) {
    this.db = DB(DbConfig)
    return this.db.init()
  }

  Vue.MigrateDb = function(DbConfig) {
    return this.db.migrateExistingTable(DbConfig)
  }

  Vue.db = function() {
    return this.db
  }
}

export default install



// WEBPACK FOOTER //
// ./src/modules/wrapper/VueDbPlugin.js